export default __webpack_public_path__ + "static/media/risk_very_high.7671791b.svg";